import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,[_c(VCard,[_c(VCardTitle,{staticClass:"justify-center"},[_c('span',{staticClass:"text-center",staticStyle:{"word-break":"normal"}},[_vm._v(_vm._s(_vm.header))])]),_c(VCardText,{staticClass:"text-center"},[_c('h1',{staticClass:"text-4xl font-weight-semibold"},[_vm._v(_vm._s(_vm.count))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }